var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.supplier_types.length > 0
      ? _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass: "required",
              staticStyle: { "margin-top": "10px" },
              attrs: { for: "supplier_type" },
            },
            [_vm._v(_vm._s(_vm.__("globals.select_type")))]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass: "form-control",
              attrs: { name: "supplier_type", id: "supplier_type" },
              on: { change: _vm.change_selector_type },
            },
            [
              _c("option", { attrs: { value: "supplier" } }, [
                _vm._v(_vm._s(_vm.__("globals.supplier"))),
              ]),
              _vm._v(" "),
              _vm._l(_vm.supplier_types, function (supplier_type) {
                return _c(
                  "option",
                  { key: supplier_type, domProps: { value: supplier_type } },
                  [_vm._v(_vm._s(supplier_type))]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("span", { staticClass: "help-block" }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.show_price
      ? _c("div", { staticClass: "card bg-gradient-primary p-2" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.__("supplier.supplier_pay")) + "\n    "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }